import { render, staticRenderFns } from "./SettingUseReason.vue?vue&type=template&id=2bd72f11&scoped=true&"
import script from "./SettingUseReason.vue?vue&type=script&lang=js&"
export * from "./SettingUseReason.vue?vue&type=script&lang=js&"
import style0 from "./SettingUseReason.vue?vue&type=style&index=0&id=2bd72f11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd72f11",
  null
  
)

export default component.exports